import React, { useId } from "react";
import PropTypes from "prop-types";

/**
 * 三態／互斥選擇 — 模板 `/ui-buttons`「Checkbox & Radio Buttons」。
 *
 * 角色權限的「編輯／唯讀／隱藏」是單選,走 radio + `.btn-check` + `.btn`(不是勾選框)。
 * 標記抄 Admin `pages/Ui/UiButtons.js`。
 *
 * 顏色(9/10 客戶回饋「有開啟權限跟無開啟權限做顏色明顯區隔」):選中的用 `color`(預設 primary 藍實底),
 * 沒選中的用模板的 soft 變體(灰字＋10% 灰底,即模板色票 Secondary 的 bg-soft)。
 * 原本三顆都是 `btn-primary`,只差 Bootstrap checked 的深淺 —— 一整欄看下去分不出哪個生效。
 *
 *   <SegmentedControl
 *     label="01 人員管理" options={PERM_LEVELS} value="read" onChange={setLevel}
 *   />
 *
 * `size="sm"` 加 `btn-sm`(軟體表單修補狀態列)。
 */
export const SegmentedControl = ({
  label, options = [], value, onChange, readOnly = false, size = "md", color = "primary",
}) => {
  const groupId = useId();
  const name = `seg-${groupId}`;
  return (
    <div
      className={`btn-group dck-segmented${size === "sm" ? " dck-segmented--sm" : ""}`}
      role="group"
      aria-label={label}
    >
      {options.map((o) => {
        const id = `${groupId}-${o.key}`;
        const active = o.key === value;
        return (
          <React.Fragment key={o.key}>
            <input
              type="radio"
              className="btn-check"
              name={name}
              id={id}
              autoComplete="off"
              checked={active}
              disabled={readOnly}
              onChange={() => !readOnly && onChange && onChange(o.key)}
              aria-label={`${label}－${o.label}`}
            />
            <label
              className={`btn btn-${active ? color : "soft-secondary"}${size === "sm" ? " btn-sm" : ""}`}
              htmlFor={id}
            >
              {o.label}
            </label>
          </React.Fragment>
        );
      })}
    </div>
  );
};
SegmentedControl.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string, label: PropTypes.node })),
  value: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  size: PropTypes.oneOf(["md", "sm"]),
  color: PropTypes.string,
};

export default SegmentedControl;
